import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import PinLists from "../views/PinList.vue";
import PinListBatchWises from "../views/PinListBatchWise.vue";
import loginView from "../views/Login.vue";
import AddSinglePins from "../views/AddSinglePin.vue";
import EditSubscriber from "../views/EditSinglePin.vue";
import AddRatePlans from "../views/AddRatePlan.vue";
import RatePlans from "../views/RatePlan.vue";
import EditRatePlans from "../views/EditRatePlan.vue";
import SaleingRatePlans from "../views/SaleingRatePlan.vue";
import AddSaleRate from "../views/AddSaleRate.vue";
import EditSaleRates from "../views/EditSaleRate.vue";

//Reseller
import ResellerLists from "../views/ResellerList.vue";
import AddNewResellers from "../views/AddNewReseller.vue";
import EditResellers from "../views/EditReseller.vue";

//IP List
import IpLists from "../views/IpLists/IpList";
import AddIps from "../views/IpLists/AddIp";
import EditIps from "../views/IpLists/EditIp";

//IP Bundle
import IpBundleLists from "../views/IpBundle/IpBundleList";
import IpBundlAdds from "../views/IpBundle/IpBundleAdd";
import IpBundlEdits from "../views/IpBundle/IpBundleEdit";
import IpBundleDtlsLists from "../views/IpBundle/IpBundleDtlsList";

//vpn servers
import Addservers from "../views/Addservers.vue";
import ServerLists from "../views/ServerLists.vue";
import EditServers from "../views/EditServer.vue";
import InstallOvpn from "../views/InstallOvpn.vue";

//App List
import AppLists from "../views/AppLists/AppList";
import AddApps from "../views/AppLists/AddApp";

//Push Template List
import TemplateLists from "../views/PushTemplates/TemplateList";
import AddTemplates from "../views/PushTemplates/AddTemplate";

//Push Template List
import PushLists from "../views/Push/PushList";
import AddPushs from "../views/Push/AddPush";

//Radius Auth Server
import AddRadiusAuth from "../views/AddRadiusAuth.vue";
import RadiusAuth from "../views/RadiusAuth.vue";
import EditRadiusAuth from "../views/EditRadiusAuth.vue";
import InstallAuth from "../views/InstallAuth.vue";

import AddPinBatchs from "../views/AddPinBatch.vue";
import EditBatchs from "../views/EditBatch.vue";
import PinBatchLists from "../views/PinBatchList.vue";
import ResellerConnectedUsers from "../views/ResellerConnectedUser.vue";
import AddPanelSettings from "../views/AddPanelSetting.vue";
import AddConfigSettings from "../views/AddConfigSetting.vue";
import PinSubscriptionReportView from "../views/reports/PinSubscriptionReport.vue";
import HourlyServerConnection from "../views/reports/HourlyServerConnectionReport.vue";
import HourlySubscriptionReportView from "../views/reports/HourlySubscriptionReport.vue";
import passwordResetView from "../views/PasswordReset.vue";

import OnlineTransactionReportView from "../views/reports/OnlineTransactionReport.vue";

//Coupons
import CouponList from '@/components/CouponList.vue'
import AddCoupons from '@/components/AddCoupons.vue'
import EditCoupon from '@/components/EditCoupon.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "loginView" },
  },
  {
    path: "/dashboard",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "loginView",
    component: loginView,
  },
  {
    path: "/subscriberslist",
    name: "PinLists",
    component: PinLists,
    meta: { requiresAuth: true },
  },
  {
    path: "/subscriberslist/:id",
    name: "PinListBatchWises",
    component: PinListBatchWises,
    meta: { requiresAuth: true },
  },
  {
    path: "/addsinglesubscriber",
    name: "AddSinglePins",
    component: AddSinglePins,
    meta: { requiresAuth: true },
  },
  {
    path: "/editsubscriber/:id",
    name: "EditSubscriber",
    component: EditSubscriber,
    meta: { requiresAuth: true },
  },
  {
    path: "/addrateplans",
    name: "AddRatePlans",
    component: AddRatePlans,
    meta: { requiresAuth: true },
  },
  {
    path: "/rateplans",
    name: "RatePlans",
    component: RatePlans,
    meta: { requiresAuth: true },
  },
  {
    path: "/edit_rateplans/:id",
    name: "EditRatePlans",
    component: EditRatePlans,
    meta: { requiresAuth: true },
  },
  {
    path: "/rateplans/:id",
    name: "SaleingRatePlans",
    component: SaleingRatePlans,
    meta: { requiresAuth: true },
  },
  {
    path: "/addsalerate/:id",
    name: "AddSaleRate",
    component: AddSaleRate,
    meta: { requiresAuth: true },
  },
  {
    path: "/editsalerate/:id",
    name: "EditSaleRates",
    component: EditSaleRates,
    meta: { requiresAuth: true },
  },
  {
    path: "/resellerlist",
    name: "ResellerLists",
    component: ResellerLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/resellerlist/:id",
    name: "EditResellers",
    component: EditResellers,
    meta: { requiresAuth: true }
  },
  {
    path: "/addresellers",
    name: "AddNewResellers",
    component: AddNewResellers,
    meta: { requiresAuth: true }
  },
  {
    path: "/iplists",
    name: "IpLists",
    component: IpLists,
    meta: { requiresAuth: true },
  },
  {
    path: "/addip",
    name: "AddIp",
    component: AddIps,
    meta: { requiresAuth: true },
  },
  {
    path: "/editip/:id",
    name: "EditIp",
    component: EditIps,
    meta: { requiresAuth: true },
  },
  {
    path: "/ipbundle",
    name: "IpBundleLists",
    component: IpBundleLists,
    meta: { requiresAuth: true },
  },
  {
    path: "/ipbundleadd",
    name: "IpBundleAdd",
    component: IpBundlAdds,
    meta: { requiresAuth: true },
  },
  {
    path: "/ipbundleedit/:id",
    name: "IpBundleEdit",
    component: IpBundlEdits,
    meta: { requiresAuth: true },
  },
  {
    path: "/ipbundledtlslist/:id",
    name: "IpBundleDtlsLists",
    component: IpBundleDtlsLists,
    meta: { requiresAuth: true },
  },
  {
    path: "/addnewserver",
    name: "Addservers",
    component: Addservers,
    meta: { requiresAuth: true },
  },
  {
    path: "/serverlists",
    name: "ServerLists",
    component: ServerLists,
    meta: { requiresAuth: true },
  },
  {
    path: "/edit_server/:id",
    name: "EditServers",
    component: EditServers,
    meta: { requiresAuth: true },
  },
  {
    path: "/install_vpn_server/:id",
    name: "InstallOvpns",
    component: InstallOvpn,
    meta: { requiresAuth: true },
  },
  {
    path: "/radius-auth-server",
    name: "RadiusAuthList",
    component: RadiusAuth,
    meta: { requiresAuth: true },
  },
  {
    path: "/add-radius-auth-server",
    name: "AddRadiusAuth",
    component: AddRadiusAuth,
    meta: { requiresAuth: true },
  },
  {
    path: "/edit-radius-auth-server/:id",
    name: "EditRadiusAuth",
    component: EditRadiusAuth,
    meta: { requiresAuth: true },
  },
  {
    path: "/install_auth_server/:id",
    name: "InstallAuth",
    component: InstallAuth,
    meta: { requiresAuth: true },
  },
  {
    path: "/addsubscriberbatchs",
    name: "AddPinBatchs",
    component: AddPinBatchs,
    meta: { requiresAuth: true },
  },
  {
    path: "/edit_batch/:id",
    name: "EditBatchs",
    component: EditBatchs,
    meta: { requiresAuth: true },
  },
  {
    path: "/subscribersbatchlist",
    name: "PinBatchLists",
    component: PinBatchLists,
    meta: { requiresAuth: true },
  },
  {
    path: "/resellerconnectedusers",
    name: "ResellerConnectedUsers",
    component: ResellerConnectedUsers,
    meta: { requiresAuth: true },
  },
  {
    path: "/panelsettings",
    name: "AddPanelSettings",
    component: AddPanelSettings,
    meta: { requiresAuth: true },
  },
  {
    path: "/configsettings",
    name: "AddConfigSettings",
    component: AddConfigSettings,
    meta: { requiresAuth: true },
  },
  {
    path: "/pinsubscriptionreport",
    name: "PinSubscriptionReportView",
    component: PinSubscriptionReportView,
    meta: { requiresAuth: true },
  },
  {
    path: "/hourlyserverconnection",
    name: "HourlyServerConnectionsView",
    component: HourlyServerConnection,
    meta: { requiresAuth: true },
  },

  {
    path: '/coupon-list',
    name: 'CouponList',
    component: CouponList
  },
  {
    path: '/addcoupon',
    name: 'AddCoupon',
    component: AddCoupons,
    // No props needed for Add mode
  },
  {
    path: '/editcoupon/:id',
    name: 'EditCoupon',
    component: EditCoupon,
    props: true // Enables passing route param 'id' as a prop
  },
  // Redirect root to coupon-list
  {
    path: '/',
    redirect: '/coupon-list'
  },

  {
    path: "/hourlysubscriptionreport",
    name: "HourlySubscriptionReportView",
    component: HourlySubscriptionReportView,
    meta: { requiresAuth: true },
  },
  {
    path: "/pagenotfound",
    name: "pagenotfound",
    component: () => import("../components/404NotFound.vue"),
  },
  {
    path: "/pagenotfound",
    name: "pagesnotfound",
    component: () => import("../components/404NotFound.vue"),
  },
  {
    path: "/logout",
    redirect: { name: "loginView" },
  },
  {
    path: "/passwordReset",
    name: "passwordReset",
    component: passwordResetView,
  },
  {
    path: "/onlinetransactionreport",
    name: "OnlineTransactionReportView",
    component: OnlineTransactionReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/applists",
    name: "AppList",
    component: AppLists,
    meta: { requiresAuth: true },
  },
  {
    path: "/addapp",
    name: "AddApp",
    component: AddApps,
    meta: { requiresAuth: true },
  },
  {
    path: "/editapp/:id",
    name: "EditApp",
    component: AddApps,
    meta: { requiresAuth: true },
  },
  {
    path: "/templatelists",
    name: "TemplateList",
    component: TemplateLists,
    meta: { requiresAuth: true },
  },
  {
    path: "/addtemplate",
    name: "AddTemplate",
    component: AddTemplates,
    meta: { requiresAuth: true },
  },
  {
    path: "/editemplate/:id",
    name: "EditTemplate",
    component: AddTemplates,
    meta: { requiresAuth: true },
  },
  {
    path: "/all-push-requests",
    name: "PushList",
    component: PushLists,
    meta: { requiresAuth: true },
  },
  {
    path: "/send-new-push",
    name: "AddPush",
    component: AddPushs,
    meta: { requiresAuth: true },
  }

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt_token") == null) {
      next({
        name: "loginView",
      });
    } else {
      next();
    }
  } else {
    if (to.name == "loginView") {
      if (localStorage.getItem("jwt_token") == null) {
        next();
      } else {
        next({
          name: "Home",
        });
      }
    } else {
      next();
    }
  }
});

export default router;
